import { type FC, type MouseEvent } from 'react';
import { Segmented, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import cn from 'classnames';
import { StatisticSectionRow } from './types';
import styles from './style.module.css';

interface Props {
  section: StatisticSectionRow;
  sectionKey: string;
  activeMode: string | undefined;
  onModeChange: (sectionKey: string, mode: string) => void;
}

const PARENTHETICAL_SUFFIX_PATTERN = /^(.*?)(\s+\([^)]*\))$/;

const stopHeaderControlToggle = (event: MouseEvent<HTMLSpanElement>) => {
  event.stopPropagation();
};

const renderSectionTitle = (title: string) => {
  const match = PARENTHETICAL_SUFFIX_PATTERN.exec(title);

  if (!match) {
    return title;
  }

  const [, baseTitle, suffix] = match;

  if (!baseTitle || !suffix) {
    return title;
  }

  return (
    <>
      {baseTitle}
      <span className={styles.categoryTitleSuffix}>{suffix}</span>
    </>
  );
};

export const SectionLabel: FC<Props> = ({
  section,
  sectionKey,
  activeMode,
  onModeChange,
}: Props) => (
  <span className={styles.categoryLabel}>
    <span className={styles.categoryHeading}>
      <span className={styles.categoryText}>
        <span
          className={cn(styles.categoryTitle, styles.categoryTitleEmphasized)}
        >
          {renderSectionTitle(section.parameter)}
        </span>
        {section.subtitle ? (
          <span className={styles.categorySubtitle}>{section.subtitle}</span>
        ) : null}
      </span>
      {section.tooltip ? (
        <Tooltip title={section.tooltip}>
          <InfoCircleOutlined
            aria-label="Описание групп результатов"
            className={styles.categoryTooltipIcon}
          />
        </Tooltip>
      ) : null}
    </span>
    {section.modeOptions?.length ? (
      <span
        className={styles.categoryModeControl}
        onClick={stopHeaderControlToggle}
        onMouseDown={stopHeaderControlToggle}
      >
        <Segmented
          size="middle"
          options={[...section.modeOptions]}
          value={activeMode}
          onChange={(value) => onModeChange(sectionKey, String(value))}
        />
      </span>
    ) : null}
  </span>
);
